import React from 'react';
import { initialState } from './settings';

export const SettingsContext = React.createContext(
    initialState.values // default value
)

export default SettingsContext